import * as React from "react"
import * as styles from "./Footer.module.scss"
import {
  FACEBOOK,
  INSTAGRAM,
  TWITTER,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
} from "../../../constants/routes"

const SpecialFooter = () => {
  return (
    <>
      <div className={styles.footer}>
        <div className={styles.footer__content}>
          <div className={styles.leftSide}>
            <div className={styles.logo}>
              <img src="https://content.landline.com/wp-content/uploads/2024/10/landline-logo-blk-small.jpg" alt="Landline logo" className={styles.AirCanadaLogo}/>
            </div>
          </div>
          <div className="rightSide">
            <div className={styles.rowOne}>
              <div className={styles.socialMediaLinks}>
                <div
                  className={styles.mediaLink}
                  onClick={() => (window.location = FACEBOOK)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.7992 12.027C22.7992 6.05048 17.9608 1.19995 11.9992 1.19995C6.03762 1.19995 1.19922 6.05048 1.19922 12.027C1.19922 17.2673 4.91442 21.6306 9.83922 22.6375V15.2751H7.67922V12.027H9.83922V9.32025C9.83922 7.23063 11.5348 5.53078 13.6192 5.53078H16.3192V8.7789H14.1592C13.5652 8.7789 13.0792 9.26612 13.0792 9.8616V12.027H16.3192V15.2751H13.0792V22.7999C18.5332 22.2586 22.7992 17.6463 22.7992 12.027Z"
                      fill="#3C3835"
                    />
                  </svg>
                </div>

                <div
                  className={styles.mediaLink}
                  onClick={() => (window.location = INSTAGRAM)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.2122 22.7999C12.1407 22.7999 12.0692 22.7999 11.9972 22.7996C10.304 22.8037 8.73953 22.7607 7.21809 22.6681C5.82321 22.5832 4.54996 22.1012 3.53577 21.2743C2.55718 20.4763 1.88891 19.3974 1.54959 18.0679C1.25426 16.9103 1.23861 15.7741 1.22361 14.675C1.21273 13.8865 1.20153 12.9521 1.19922 12.0019C1.20153 11.0477 1.21273 10.1133 1.22361 9.3248C1.23861 8.22594 1.25426 7.08968 1.54959 5.93199C1.88891 4.60242 2.55718 3.52351 3.53577 2.72557C4.54996 1.89862 5.82321 1.4166 7.21825 1.33173C8.7397 1.23928 10.3045 1.1961 12.0013 1.20022C13.6949 1.19659 15.2589 1.23928 16.7803 1.33173C18.1752 1.4166 19.4485 1.89862 20.4627 2.72557C21.4414 3.52351 22.1095 4.60242 22.4489 5.93199C22.7442 7.08951 22.7598 8.22594 22.7748 9.3248C22.7857 10.1133 22.7971 11.0477 22.7992 11.9979V12.0019C22.7971 12.9521 22.7857 13.8865 22.7748 14.675C22.7598 15.7739 22.7443 16.9102 22.4489 18.0679C22.1095 19.3974 21.4414 20.4763 20.4627 21.2743C19.4485 22.1012 18.1752 22.5832 16.7803 22.6681C15.3233 22.7568 13.8266 22.7999 12.2122 22.7999ZM11.9972 21.1121C13.6628 21.1161 15.1922 21.074 16.6778 20.9837C17.7326 20.9196 18.6471 20.5774 19.3962 19.9665C20.0887 19.4017 20.5657 18.6226 20.8137 17.6506C21.0596 16.687 21.0737 15.6524 21.0874 14.652C21.0981 13.8687 21.1093 12.9409 21.1117 11.9999C21.1093 11.0588 21.0981 10.1311 21.0874 9.34787C21.0737 8.3474 21.0596 7.31281 20.8137 6.34909C20.5657 5.37712 20.0887 4.59797 19.3962 4.03322C18.6471 3.42249 17.7326 3.08021 16.6778 3.0161C15.1922 2.92563 13.6628 2.88393 12.0011 2.88756C10.3358 2.8836 8.80628 2.92563 7.32059 3.0161C6.26587 3.08021 5.35139 3.42249 4.6022 4.03322C3.9097 4.59797 3.43277 5.37712 3.18474 6.34909C2.93886 7.31281 2.92469 8.34723 2.91101 9.34787C2.9003 10.1318 2.88909 11.0601 2.88678 12.0019C2.88909 12.9396 2.9003 13.868 2.91101 14.652C2.92469 15.6524 2.93886 16.687 3.18474 17.6506C3.43277 18.6226 3.9097 19.4017 4.6022 19.9665C5.35139 20.5772 6.26587 20.9195 7.32059 20.9836C8.80628 21.074 10.3361 21.1162 11.9972 21.1121ZM11.9569 17.2734C9.04919 17.2734 6.68331 14.9077 6.68331 11.9999C6.68331 9.09211 9.04919 6.72647 11.9569 6.72647C14.8649 6.72647 17.2306 9.09211 17.2306 11.9999C17.2306 14.9077 14.8649 17.2734 11.9569 17.2734ZM11.9569 8.41397C9.97966 8.41397 8.37087 10.0227 8.37087 11.9999C8.37087 13.9771 9.97966 15.5859 11.9569 15.5859C13.9344 15.5859 15.543 13.9771 15.543 11.9999C15.543 10.0227 13.9344 8.41397 11.9569 8.41397ZM17.8212 5.03896C17.1223 5.03896 16.5556 5.60553 16.5556 6.30459C16.5556 7.00365 17.1223 7.57022 17.8212 7.57022C18.5203 7.57022 19.0869 7.00365 19.0869 6.30459C19.0869 5.60553 18.5203 5.03896 17.8212 5.03896Z"
                      fill="#3C3835"
                    />
                  </svg>
                </div>

                <div
                  className={styles.mediaLink}
                  onClick={() => (window.location = TWITTER)}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8.277 20.25C16.4333 20.25 20.8931 13.9006 20.8931 8.39764C20.8931 8.21625 20.8931 8.0348 20.8839 7.86204C21.7483 7.27463 22.5023 6.54032 23.1 5.70236C22.3092 6.03064 21.454 6.25527 20.5529 6.35893C21.4724 5.84057 22.1713 5.02854 22.5023 4.05236C21.6472 4.52748 20.7 4.87307 19.6885 5.06309C18.8793 4.25105 17.7299 3.75 16.4518 3.75C14.0057 3.75 12.0196 5.616 12.0196 7.91389C12.0196 8.24218 12.0563 8.56179 12.1391 8.86414C8.45172 8.69138 5.18736 7.03275 2.99886 4.51023C2.62182 5.12357 2.40114 5.84057 2.40114 6.6008C2.40114 8.04348 3.18276 9.32202 4.37814 10.0649C3.65172 10.0476 2.97126 9.85763 2.37354 9.54659V9.59845C2.37354 11.6199 3.9 13.2958 5.9322 13.6846C5.5644 13.7796 5.169 13.8314 4.76436 13.8314C4.4793 13.8314 4.20348 13.8055 3.9276 13.7537C4.48854 15.4123 6.12528 16.6131 8.0655 16.6476C6.54828 17.7621 4.63566 18.4272 2.5575 18.4272C2.19888 18.4272 1.84944 18.41 1.5 18.3667C3.44022 19.5589 5.77584 20.25 8.277 20.25Z"
                      fill="#3C3835"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div className={styles.rowTwo}>
              <div className={styles.legal}>
                <p>
                  ©{new Date().getFullYear()} The Landline Company. All Rights
                  Reserved.
                </p>
              </div>
            </div>

            <div className={styles.linksWrapper}>
              <div className={styles.linkContent}>
                <a href={TERMS_AND_CONDITIONS}>Terms and Conditions</a>
                <span> |&nbsp;</span>
                <a href={PRIVACY_POLICY}>Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

SpecialFooter.propTypes = {}

SpecialFooter.defaultProps = {}

export default SpecialFooter
